var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sb-metric-tiles" },
    _vm._l(_vm.metrics, function(m, i) {
      return _c(
        "div",
        { key: i, class: ["sb-metric-tile", m.variant || "default"] },
        [
          _c("span", { staticClass: "sb-metric-label" }, [
            _vm._v(_vm._s(m.label))
          ]),
          _vm._v(" "),
          _c("span", { class: ["sb-metric-val", m.variant] }, [
            _vm._v("\n      " + _vm._s(m.value) + "\n      "),
            m.trend
              ? _c("span", { staticClass: "sb-metric-trend" }, [
                  _vm._v(_vm._s(m.trend))
                ])
              : _vm._e()
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }